export default {
  expandedPush: 'Развернутый пуш',
  open: 'Открыть',
  placeholder: 'Строка символов{{index}}',
  variable: 'Переменная',
  allButtons: 'Все кнопки',
  expandButtons: 'Развернуть кнопки',
  allPossibilities: 'Все возможности',
};
